export default __webpack_public_path__ + "static/media/shoppingimage.c6379bbc.jpg";